import { mixins } from 'vue-class-component';
import { Component, Prop } from 'vue-property-decorator';
import FieldWrapper from '../field-wrapper/field-wrapper.vue';
import AbstractField from '../abstract-field/abstract-field';
import { ActivityGroup } from '@activities/interfaces/activity-group';
import BpcActivityGroupTable from '@activities/components/tables/activity-group-table/activity-group-table.vue';

@Component({
  name: 'bpc-activity-group-table-input',
  components: {
    BpcActivityGroupTable,
    'bpc-field-wrapper': FieldWrapper,
  },
})
export default class ActivityGroupTableInput extends mixins(AbstractField) {
  declare $refs: AbstractField['$refs'] & {
    attendeeTable: InstanceType<typeof BpcActivityGroupTable> & {
      getEntities(): void;
    };
  };
  @Prop(Array) readonly value: any[];
  @Prop(Object) readonly externalFormModel: object;

  @Prop({ type: String, default: 'drawer' }) readonly type: string;
  @Prop(String) readonly selectEntity: string;

  @Prop(Array) readonly filters: any[];
  @Prop(String) readonly fieldForStorage: string;

  @Prop(Boolean) readonly withDraft: boolean;
  @Prop({ type: String, default: 'default' })
  readonly formConfigName: string;
  @Prop({ type: String, default: 'edit' })
  readonly editFormConfigName: string;
  @Prop({
    type: Array,
    default: () => {
      return ['default'];
    },
  })
  readonly selectConfigName: string[];
  @Prop({ type: Boolean, default: true }) readonly showTableHeader: boolean;
  @Prop({ type: Boolean, default: true }) readonly withSearch: boolean;
  @Prop({ type: Boolean, default: true }) readonly withFilters: boolean;
  @Prop({ type: Boolean, default: true }) readonly showPagination: boolean;
  @Prop({ type: Boolean, default: true }) readonly showTabFilters: boolean;
  @Prop({ type: Boolean, default: true }) readonly showOrderBy: boolean;

  @Prop({
    type: Array,
    default: () => ['configLoaded', 'filtersLoaded', 'paginationLoaded', 'orderLoaded'],
  })
  readonly customFlagsToCheckBeforeLoadEntities: Array<any>;
  @Prop({ type: String, default: 'table-input' }) readonly displayConfigName: string;
  @Prop({ type: String, default: 'default' }) readonly filterConfigName: string;

  get model(): any[] {
    return this.value;
  }
  set model(val: any[]) {
    this.$emit('input', val);
    if (this.eventsConfig && this.eventsConfig.emit) {
      this.eventsConfig.emit.forEach(event => {
        this.$root.$emit(event, val);
      });
    }
  }

  public entity: ActivityGroup = null;
  public entityName = 'activity-group';
  public pluralEntityName = 'activity-groups';
  public permissionEntityNameToUse = 'activity_groups';

  getEntities() {
    return this.$refs.attendeeTable?.getEntities();
  }

  onChange($event) {
    this.$emit('change', $event);
  }

  get mode(): string {
    return 'api';
  }
}
